import { RegisterOption } from './register-option';

export class RegisterOptionMapper {
  static toModel(data: any): RegisterOption[] {
    return data.map(
      (v: any): RegisterOption => ({
        value: v.id,
        label: v.name,
        storeId: v.storeId,
        id: v.id,
        min: v.machineIdentificationNumber || undefined,
        serialNumber: v.serialNumber || undefined,
      })
    );
  }
}
